import { ActionTree } from 'vuex';
import { AwsServiceState } from '@/store/modules/cloud/aws/aws.store';
import {
  AUTO_INSTALL_ALL,
  GET_INSTALLED_SERVICES,
  INSTALL_SERVICES_MANUALLY,
  SERVICE_LEVEL_AUTO_INSTALL,
  TOGGLE_MONITORING,
  UPDATE_SERVICE_DETAIL,
} from './aws.constants';
import { CloudService } from '@/services/api/integration.service';

const awsServiceActions: ActionTree<AwsServiceState, any> = {
  async [GET_INSTALLED_SERVICES]({ commit }, params) {
    const { data } = await CloudService.getInstalledServices(params);
    if (data.success === true) return data.services;
  },
  async [SERVICE_LEVEL_AUTO_INSTALL]({ commit }, params) {
    const { data } = await CloudService.handleServiceLevelAutoInstall(params);
    if (data.success === true) return data;
  },
  async [TOGGLE_MONITORING]({ commit }, params) {
    const { data } = await CloudService.toggleMonitoring(params);
    if (data.success === true) return data;
  },
  async [INSTALL_SERVICES_MANUALLY]({ commit }, params) {
    const { data } = await CloudService.installServicesManually(params);
    return data;
  },
  async [UPDATE_SERVICE_DETAIL]({ commit }, params) {
    const { data } = await CloudService.updateServiceInfo(params);
    return data;
  },
  async [AUTO_INSTALL_ALL]({ commit }, params) {
    const data = await CloudService.handleAutoInstallAll(params);
    return data;
  },
};

export default awsServiceActions;
